import cookie from 'js-cookie'

const TokenKey = 'token'

const AdminTokenKey = 'admin-token'

const AssistantIdKey = 'assistant-id'

// 桂教通试听页的登录凭证只保存在当前页面内存，不覆盖站内原有登录 Cookie。
let gjtTrialToken = ''

export function getToken () {
  return gjtTrialToken || cookie.get(TokenKey)
}

export function setGjtTrialToken (token) {
  gjtTrialToken = token
}

export function clearGjtTrialToken () {
  gjtTrialToken = ''
}
//
export function setToken (token) {
  return cookie.set(TokenKey, token, {
    expires: 28
  })
}
//
export function removeToken () {
  return cookie.remove(TokenKey)
}

export function getAdminToken () {
  return cookie.get(AdminTokenKey)
}
//
export function setAdminToken (token) {
  return cookie.set(AdminTokenKey, token, {
    expires: 28
  })
}
//
export function removeAdminToken () {
  return cookie.remove(AdminTokenKey)
}

export function getAssistantId () {
  return cookie.get(AssistantIdKey)
}
//
export function setAssistantId (token) {
  return cookie.set(AssistantIdKey, token, {
    expires: 28
  })
}
//
export function removeAssistantId () {
  return cookie.remove(AssistantIdKey)
}
